import { jsx as _jsx } from "react/jsx-runtime";
import { KeyboardArrowLeft as KeyboardArrowLeft } from "@mui/icons-material";
import { Divider, IconButton } from "@mui/material";
export const DividerWithToggle = ({ open, onToggle }) => {
    return (_jsx(Divider, { orientation: "vertical", flexItem: true, sx: { "&::before": { height: "16px" }, "&::after": { height: "100%" } }, children: _jsx(IconButton, { size: "small", onClick: () => {
                onToggle(!open);
            }, children: _jsx(KeyboardArrowLeft, { sx: {
                    transition: "transform 0.2s ease-out",
                    ...(!open ? { transform: `rotate(-180deg)` } : undefined),
                } }) }) }));
};
//# sourceMappingURL=DividerWithToggle.js.map